import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

const Styles = labelStyles("TableHead", {
  root: css`
    display: table-header-group;
  `
});
const TableHead = (props) => {
  return jsx("thead", { css: Styles.root, "data-zds": true }, props.children);
};

export { TableHead };
//# sourceMappingURL=TableHead.es.js.map
